import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27d3733b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "avatar-stack-wrapper" }
const _hoisted_2 = { class: "avatar-stack" }
const _hoisted_3 = {
  key: 0,
  class: "avatar-more avatar-wrapper"
}
const _hoisted_4 = { class: "is-more" }
const _hoisted_5 = { class: "inner" }
const _hoisted_6 = {
  key: 0,
  class: "avatar-list-content"
}
const _hoisted_7 = { class: "mr-1" }
const _hoisted_8 = { key: 0 }

import { computed, PropType } from 'vue'
interface IAvatar {
  avatar: string
  label?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AvatarStack',
  props: {
  avatars: {
    type: Array as PropType<IAvatar[]>,
    default: () => [],
  },
  limit: {
    type: Number,
    default: 3,
  },
  size: {
    type: Number,
    default: 48,
  },
  hasDot: {
    type: Boolean,
    default: false,
  },
  showAvatarList: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "2ed2ef31": (width.value),
  "dc8805c8": (height.value)
}))

const props = __props
const width = computed(() => `${props.size}px`)
const height = computed(() => `${props.size}px`)
const limitAvatars = computed(() => props.avatars.slice(0, props.limit))
const isMore = computed(() => props.avatars.length > props.limit)
const avatarListLabel = computed(() => limitAvatars.value.map(({ label }) => label).join(', '))
const nMoreAvatar = computed(() => (isMore.value ? props.avatars.length - props.limit : 0))

return (_ctx: any,_cache: any) => {
  const _component_Avatar = _resolveComponent("Avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(limitAvatars.value, (user, index) => {
        return (_openBlock(), _createBlock(_component_Avatar, {
          key: index,
          size: __props.size,
          avatar: user.avatar,
          "has-dot": ""
        }, null, 8, ["size", "avatar"]))
      }), 128)),
      (isMore.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createElementVNode("span", null, "+" + _toDisplayString(nMoreAvatar.value), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (__props.showAvatarList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          (!_ctx.$slots['avatar-list'])
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(avatarListLabel.value), 1),
                (isMore.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "And " + _toDisplayString(nMoreAvatar.value) + " more", 1))
                  : _createCommentVNode("", true)
              ], 64))
            : _renderSlot(_ctx.$slots, "avatar-list", {
                key: 1,
                props: { avatarListLabel: avatarListLabel.value, nMoreAvatar: nMoreAvatar.value },
                avatarListLabel: avatarListLabel.value,
                nMoreAvatar: nMoreAvatar.value
              })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})